import React, { useRef } from 'react';
import styled from 'styled-components';
const StyledOverlay = styled.div `
  ${({ $fullScreenSmDown, $fullScreenMdOnly, $isIntersectingViewport, theme: { media, space }, }) => `
    @media print {
      position: static;
    }
    background: hsla(0, 0%, 0%, 0.3);
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    height: 100%;
    overflow: auto;
    z-index: 10;
    display: flex;
    justify-content: center;
    padding: ${space.lg} 0;
    align-items: ${$isIntersectingViewport ? 'flex-start' : 'center'};

    ${media.down('sm')} {
      ${$fullScreenSmDown ? 'align-items: flex-start; padding: 0;' : ''} 
    }

    ${media.between('md', 'md')} {
      ${$fullScreenMdOnly ? 'align-items: flex-start; padding: 0;' : ''} 
    }
  `}
`;
export const OverlayBase = ({ $fullScreenSmDown, $fullScreenMdOnly, $isIntersectingViewport, children, open, onClick, }) => {
    const overlayRef = useRef(null);
    const mouseDownTargetRef = useRef(false);
    const mouseUpTargetRef = useRef(false);
    if (open) {
        return (React.createElement(StyledOverlay, { ref: (r) => {
                overlayRef.current = r;
            }, 
            // We compare the ref to the target to make sure the click event
            // originated in the overlay and wasn't bubbled up from an element inside modal
            onMouseDown: (e) => {
                if (e.target === overlayRef.current) {
                    mouseDownTargetRef.current = true;
                }
            }, onMouseUp: (e) => {
                if (e.target === overlayRef.current && mouseDownTargetRef.current) {
                    mouseUpTargetRef.current = true;
                }
                else {
                    mouseDownTargetRef.current = false;
                }
            }, onClick: (e) => {
                // Checks that a click starts and ends on the overlay and closes the modal if it has.
                if (mouseDownTargetRef.current &&
                    mouseUpTargetRef.current &&
                    e.target === overlayRef.current) {
                    onClick();
                }
                mouseDownTargetRef.current = false;
                mouseDownTargetRef.current = false;
            }, "$fullScreenSmDown": $fullScreenSmDown, "$fullScreenMdOnly": $fullScreenMdOnly, "$isIntersectingViewport": $isIntersectingViewport, "data-testid": "modal-overlay" }, children));
    }
    return null;
};
//# sourceMappingURL=OverlayBase.js.map